const peruntukanBangunan = [
  "2A1 - Rumah Tangga Sangat Sederhana 1",
  "2A1A - Rumah Tangga Sangat Sederhana 2",
  "2A2 - Rumah Tangga Sederhana 1",
  "2A2A - Rumah Tangga Sederhana 2",
  "2A3 - Rumah Tangga Menengah 1",
  "2A3A - Rumah Tangga Menengah 2",
  "2A4 - Rumah Tangga Diatas Menengah",
  "2A4A - Rumah Tangga Diatas Menengah 2",
  "1A - Asrama Badan Sosial",
  "1B - Rumah Yatim Piatu",
  "1C - Tempat Ibadah",
  "5A - Hidran Kebakaran",
  "1D - Fasilitas Kesehatan Milik Pemerintah",
  "5B1 - Kios Air",
  "5A1 - Usaha Kecil Dalam Rumah Tangga (Ledeng Umum/MCK)",
  "5F1 - Rumah Susun Sangat Sederhana",
  "5FP  - Rumah Susun Sederhana Sewa - Pemerintah",
  "5F2 - Rumah Susun Sederhana",
  "2E1 - Niaga/Industri Kecil (Lembaga Swasta Non Komersial)",
  "3A - Niaga/Industri Kecil (Kios/Warung)",
  "3B1 - Niaga/Industri Kecil (Bengkel Kecil)",
  "3C1 - Niaga/Industri Kecil (Usaha Kecil)",
  "3D1 - Usaha Kecil Dalam Rumah Tangga",
  "5F3 - Rumah Susun Menengah",
  "2B - Instansi Luar Negeri (Kedutaan/Konsulat)",
  "2C - Instansi dan Fasilitas Pemerintah",
  "2D - Instansi Luar Negeri (Kantor Perwakilan Asing)",
  "2E - Niaga/Industri Menengah (Lembaga Swasta Komersial)",
  "2F - Instansi Pendidikan Pemerintah",
  "2G - Instansi dan Fasilitas Pemerintah",
  "3B - Niaga/Industri Menengah (Bengkel Menengah)",
  "3C - Niaga/Industri Menengah (Usaha Menengah)",
  "3D - Usaha Menengah Dalam Rumah Tangga",
  "3E - Niaga/Industri Menengah (Tempat Pangkas Rambut)",
  "3F - Niaga/Industri Menengah (Penjahit)",
  "3G - Niaga/Industri Menengah (Rumah Makan/Restauran Kecil)",
  "3H - Fasilitas Kesehatan Swasta",
  "3I - Niaga/Industri Menengah (Praktek Dokter)",
  "3J - Niaga/Industri Menengah (Kantor Pengacara)",
  "3K - Niaga/Industri Menengah (Hotel Melati (Non Bintang))",
  "4A - Niaga/Industri Menengah (Industri Menengah)",
  "5F4 - Rumah Susun Diatas Menengah",
  "3L - Gedung Bertingkat Tinggi/Apartemen/Kondominium (Hotel berbintang 1,2,3/Motel)",
  "3M - Niaga/Industri Besar (Steambath/Salon Kecantikan)",
  "3N - Niaga/Industri Besar (Night Club/Kafe)",
  "3O - Niaga/Industri Besar (Bank)",
  "3P - Niaga/Industri Besar (Service Station/Bengkel Besar)",
  "3Q - Niaga/Industri Besar (Perusahaan Perdagangan/Niaga/Ruko/Rukan)",
  "3R - Niaga/Industri Besar (Hotel Berbintang 4, 5/Cottage)",
  "3S - Gedung Bertingkat Tinggi Komersial/Apartemen/Kondominium/Pusat Perbelanjaan",
  "4B - Niaga/Industri Besar (Pabrik Es)",
  "4C - Niaga/Industri Besar (Pabrik Makanan/Minuman)",
  "4D - Niaga/Industri Besar (Pabrik Kimia/Obat/Kosmetik/Plastik)",
  "4E - Niaga/Industri Besar (Pabrik/Gedung Perindustrian)",
  "4F - Niaga/Industri Besar (Pabrik Tekstil)",
  "4C - Niaga/Industri Besar (Pergudangan/Industri Lainnya)",
  "5C -  Niaga/Industri Besar (Kapal Tongkang)",
  "5E - Niaga/Industri Besar (Tempat Wisata)",
  "5D - Pelabuhan Laut dan Udara"
];

const sumberAir = [
  "Air tanah",
  "Tidak ada sumber air lainnya",
  "Pengolahan air",
  "Air daur ulang",
  "Lainnya"
]

const jenisGalian = [
  'Aspal',
  'Conblok',
  'Beton',
  'Sirtu',
  'Tanah'
]

const skemaPembayaran = [
  // '1x (First Bill)',
  // '3x',
  // '6x',
  // '12x',
  'CM01',
  'CM02',
  'CM03',
  'CM04',
]

const cancelReason = [
  'Pendaftaran Berulang',
  'Pelanggan berubah pikiran',
  'Tidak mendapatkan izin pemilik lahan / persil',
  'Ex - Pelanggan tidak membayar tunggakan',
  'Ex- Illegal  tidak membayar denda',
  'Kategori Regular Customer',
  'Kategori Corporate Customer',
  'Lahan Kosong'
]

const peruntukanRegistrasi = [
  { kategori: "Fasilitas Sosial", peruntukanBangunan: "Asrama Badan Sosial", jenisPelanggan: "Regular" },
  { kategori: "Fasilitas Sosial", peruntukanBangunan: "Hidran Kebakaran", jenisPelanggan: "RCC" },
  { kategori: "Fasilitas Sosial", peruntukanBangunan: "Rumah Yatim Piatu", jenisPelanggan: "Regular" },
  { kategori: "Fasilitas Sosial", peruntukanBangunan: "Tempat Ibadah", jenisPelanggan: "Regular" },
  { kategori: "Pabrik", peruntukanBangunan: "Pabrik Es", jenisPelanggan: "RCC" },
  { kategori: "Pabrik", peruntukanBangunan: "Pabrik Kimia / Obat / Kosmetik / Plastik", jenisPelanggan: "RCC" },
  { kategori: "Pabrik", peruntukanBangunan: "Pabrik Makanan/Minuman", jenisPelanggan: "RCC" },
  { kategori: "Pabrik", peruntukanBangunan: "Pabrik Tekstil", jenisPelanggan: "RCC" },
  { kategori: "Pabrik", peruntukanBangunan: "Pabrik / Gedung Perindustrian", jenisPelanggan: "Regular" },
  { kategori: "Pabrik", peruntukanBangunan: "Pergudangan / Industri Lainnya", jenisPelanggan: "Regular" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Fasilitas Warga (Balai RW, Balai RT, RPTRA)", jenisPelanggan: "Regular" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Instansi dan Kantor Pemerintah (Kantor Lurah / Kantor Dinas / Kantor BUMD / TNI / POLRI)", jenisPelanggan: "RCC" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Instansi Pendidikan Pemerintah (Sekolah Negeri / Perguran Tinggi Negeri)", jenisPelanggan: "RCC" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Kantor Perwakilan Asing", jenisPelanggan: "RCC" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Kedutaan / Konsulat", jenisPelanggan: "RCC" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Pelabuhan Laut dan Udara", jenisPelanggan: "RCC" },
  { kategori: "Pemerintahan", peruntukanBangunan: "Rumah Sakit Pemerintah / Puskesmas", jenisPelanggan: "RCC" },
  { kategori: "Rumah Susun / Apartemen", peruntukanBangunan: "Apartemen / Kondominium", jenisPelanggan: "RCC" },
  { kategori: "Rumah Susun / Apartemen", peruntukanBangunan: "Rusun Pemerintah", jenisPelanggan: "RCC" },
  { kategori: "Rumah Tangga", peruntukanBangunan: "Rumah Dinas TNI / POLRI / PNS", jenisPelanggan: "RCC" },
  { kategori: "Rumah Tangga", peruntukanBangunan: "Rumah Tangga", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Bank", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Bengkel Kecil", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Bengkel Menengah / Cuci Motor", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Bengkel Besar / Service Station / Cuci Mobil dan Motor", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Gedung Bertingkat/Pusat Perbelanjaan", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Hotel Melati (Non Bintang)", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Hotel Berbintang 1, 2, 3 / Motel", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Hotel Berbintang 4, 5 / Cottage", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Kantor Pengacara", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Kapal Tongkang", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Kios Air (Non Perpipaan)", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Ledeng Umum / MCK", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Night Club / Kafe", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Penjahit", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Praktik Dokter / Poliklinik Kecil / Laboratorium Kecil", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Rumah Sakit Swasta Besar / Poliklinik Besar / Laboratorium Besar", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Ruko /Rukan / Niaga / Perusahaan Perdagangan", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Rumah Makan / Restauran Kecil", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Sekolah Swasta Internasional / Perguruan tinggi Swasta", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Steambath / Salon Kecantikan", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Tempat Pangkas Rambut", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Tempat Wisata", jenisPelanggan: "RCC" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Usaha Kecil Dalam Rumah Tangga / Kios / Warung", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Usaha Menengah Dalam Rumah Tangga", jenisPelanggan: "Regular" },
  { kategori: "Usaha / Niaga", peruntukanBangunan: "Yayasan Swasta / Sekolah Swasta Lokal", jenisPelanggan: "Regular" }
];

const kategoriPeruntukanRegistrasi = [
  "Fasilitas Sosial",
  "Pabrik",
  "Pemerintahan",
  "Rumah Susun / Apartemen",
  "Rumah Tangga",
  "Usaha / Niaga"
];

const districts = [
  {
    "label": "Cempaka Putih Barat",
    "value": "Cempaka Putih Barat"
  },
  {
    "label": "Cempaka Putih Timur",
    "value": "Cempaka Putih Timur"
  },
  {
    "label": "Galur",
    "value": "Galur"
  },
  {
    "label": "Harapan Mulya",
    "value": "Harapan Mulya"
  },
  {
    "label": "Johar Baru",
    "value": "Johar Baru"
  },
  {
    "label": "Kampung Rawa",
    "value": "Kampung Rawa"
  },
  {
    "label": "Kramat",
    "value": "Kramat"
  },
  {
    "label": "Rawasari",
    "value": "Rawasari"
  },
  {
    "label": "Bendungan Hilir",
    "value": "Bendungan Hilir"
  },
  {
    "label": "Gelora",
    "value": "Gelora"
  },
  {
    "label": "Karet",
    "value": "Karet"
  },
  {
    "label": "Karet Kuningan",
    "value": "Karet Kuningan"
  },
  {
    "label": "Karet Semanggi",
    "value": "Karet Semanggi"
  },
  {
    "label": "Kebon Melati",
    "value": "Kebon Melati"
  },
  {
    "label": "Kebon Kacang",
    "value": "Kebon Kacang"
  },
  {
    "label": "Petamburan",
    "value": "Petamburan"
  },
  {
    "label": "Cideng",
    "value": "Cideng"
  },
  {
    "label": "Duri Pulo",
    "value": "Duri Pulo"
  },
  {
    "label": "Gambir",
    "value": "Gambir"
  },
  {
    "label": "Petojo Selatan",
    "value": "Petojo Selatan"
  },
  {
    "label": "Petojo Utara",
    "value": "Petojo Utara"
  },
  {
    "label": "Kebon Sirih",
    "value": "Kebon Sirih"
  },
  {
    "label": "Menteng",
    "value": "Menteng"
  },
  {
    "label": "Pegangsaan",
    "value": "Pegangsaan"
  },
  {
    "label": "Kenari",
    "value": "Kenari"
  },
  {
    "label": "Serdang",
    "value": "Serdang"
  },
  {
    "label": "Sumur Batu",
    "value": "Sumur Batu"
  },
  {
    "label": "Utan Panjang",
    "value": "Utan Panjang"
  },
  {
    "label": "Gunung Sahari Selatan",
    "value": "Gunung Sahari Selatan"
  },
  {
    "label": "Gunung Sahari Utara",
    "value": "Gunung Sahari Utara"
  },
  {
    "label": "Kamal Muara",
    "value": "Kamal Muara"
  },
  {
    "label": "Kapuk Muara",
    "value": "Kapuk Muara"
  },
  {
    "label": "Pejagalan",
    "value": "Pejagalan"
  },
  {
    "label": "Pluit",
    "value": "Pluit"
  },
  {
    "label": "Penjaringan",
    "value": "Penjaringan"
  },
  {
    "label": "Ancol",
    "value": "Ancol"
  },
  {
    "label": "Pademangan Barat",
    "value": "Pademangan Barat"
  },
  {
    "label": "Pademangan Timur",
    "value": "Pademangan Timur"
  },
  {
    "label": "Gunung Sahari Utara",
    "value": "Gunung Sahari Utara"
  },
  {
    "label": "Sunter Agung",
    "value": "Sunter Agung"
  },
  {
    "label": "Sunter Jaya",
    "value": "Sunter Jaya"
  },
  {
    "label": "Papanggo",
    "value": "Papanggo"
  },
  {
    "label": "Kebon Bawang",
    "value": "Kebon Bawang"
  },
  {
    "label": "Warakas",
    "value": "Warakas"
  },
  {
    "label": "Tanjung Priok",
    "value": "Tanjung Priok"
  },
  {
    "label": "Sungai Bambu",
    "value": "Sungai Bambu"
  },
  {
    "label": "Lagoa",
    "value": "Lagoa"
  },
  {
    "label": "Koja",
    "value": "Koja"
  },
  {
    "label": "Tugu Utara",
    "value": "Tugu Utara"
  },
  {
    "label": "Tugu Selatan",
    "value": "Tugu Selatan"
  },
  {
    "label": "Rawa Badak Utara",
    "value": "Rawa Badak Utara"
  },
  {
    "label": "Rawa Badak Selatan",
    "value": "Rawa Badak Selatan"
  },
  {
    "label": "Kelapa Gading Barat",
    "value": "Kelapa Gading Barat"
  },
  {
    "label": "Kelapa Gading Timur",
    "value": "Kelapa Gading Timur"
  },
  {
    "label": "Pegangsaan Dua",
    "value": "Pegangsaan Dua"
  },
  {
    "label": "Cilincing",
    "value": "Cilincing"
  },
  {
    "label": "Semper Barat",
    "value": "Semper Barat"
  },
  {
    "label": "Semper Timur",
    "value": "Semper Timur"
  },
  {
    "label": "Sukapura",
    "value": "Sukapura"
  },
  {
    "label": "Kalibaru",
    "value": "Kalibaru"
  },
  {
    "label": "Marunda",
    "value": "Marunda"
  },
  {
    "label": "Duri Kepa",
    "value": "Duri Kepa"
  },
  {
    "label": "Kebon Jeruk",
    "value": "Kebon Jeruk"
  },
  {
    "label": "Kelapa Dua",
    "value": "Kelapa Dua"
  },
  {
    "label": "Sukabumi Utara",
    "value": "Sukabumi Utara"
  },
  {
    "label": "Sukabumi Selatan",
    "value": "Sukabumi Selatan"
  },
  {
    "label": "Kedoya Utara",
    "value": "Kedoya Utara"
  },
  {
    "label": "Kedoya Selatan",
    "value": "Kedoya Selatan"
  },
  {
    "label": "Palmerah",
    "value": "Palmerah"
  },
  {
    "label": "Slipi",
    "value": "Slipi"
  },
  {
    "label": "Kemanggisan",
    "value": "Kemanggisan"
  },
  {
    "label": "Kota Bambu Utara",
    "value": "Kota Bambu Utara"
  },
  {
    "label": "Kota Bambu Selatan",
    "value": "Kota Bambu Selatan"
  },
  {
    "label": "Jati Pulo",
    "value": "Jati Pulo"
  },
  {
    "label": "Tanjung Duren Utara",
    "value": "Tanjung Duren Utara"
  },
  {
    "label": "Tanjung Duren Selatan",
    "value": "Tanjung Duren Selatan"
  },
  {
    "label": "Tomang",
    "value": "Tomang"
  },
  {
    "label": "Grogol",
    "value": "Grogol"
  },
  {
    "label": "Wijaya Kusuma",
    "value": "Wijaya Kusuma"
  },
  {
    "label": "Jelambar",
    "value": "Jelambar"
  },
  {
    "label": "Jelambar Baru",
    "value": "Jelambar Baru"
  },
  {
    "label": "Angke",
    "value": "Angke"
  },
  {
    "label": "Krendang",
    "value": "Krendang"
  },
  {
    "label": "Tambora",
    "value": "Tambora"
  },
  {
    "label": "Duri Utara",
    "value": "Duri Utara"
  },
  {
    "label": "Duri Selatan",
    "value": "Duri Selatan"
  },
  {
    "label": "Jembatan Lima",
    "value": "Jembatan Lima"
  },
  {
    "label": "Jembatan Besi",
    "value": "Jembatan Besi"
  },
  {
    "label": "Tanah Sareal",
    "value": "Tanah Sareal"
  },
  {
    "label": "Roa Malaka",
    "value": "Roa Malaka"
  },
  {
    "label": "Pekojan",
    "value": "Pekojan"
  },
  {
    "label": "Pinangsia",
    "value": "Pinangsia"
  },
  {
    "label": "Glodok",
    "value": "Glodok"
  },
  {
    "label": "Cipete Utara",
    "value": "Cipete Utara"
  },
  {
    "label": "Cipete Selatan",
    "value": "Cipete Selatan"
  },
  {
    "label": "Gandaria Utara",
    "value": "Gandaria Utara"
  },
  {
    "label": "Gandaria Selatan",
    "value": "Gandaria Selatan"
  },
  {
    "label": "Kramat Pela",
    "value": "Kramat Pela"
  },
  {
    "label": "Melawai",
    "value": "Melawai"
  },
  {
    "label": "Petogogan",
    "value": "Petogogan"
  },
  {
    "label": "Pulo",
    "value": "Pulo"
  },
  {
    "label": "Selong",
    "value": "Selong"
  },
  {
    "label": "Senayan",
    "value": "Senayan"
  },
  {
    "label": "Gunung",
    "value": "Gunung"
  },
  {
    "label": "Bukit Duri",
    "value": "Bukit Duri"
  },
  {
    "label": "Manggarai",
    "value": "Manggarai"
  },
  {
    "label": "Manggarai Selatan",
    "value": "Manggarai Selatan"
  },
  {
    "label": "Tebet Barat",
    "value": "Tebet Barat"
  },
  {
    "label": "Tebet Timur",
    "value": "Tebet Timur"
  },
  {
    "label": "Cilandak Barat",
    "value": "Cilandak Barat"
  },
  {
    "label": "Gandaria Tengah",
    "value": "Gandaria Tengah"
  },
  {
    "label": "Pondok Labu",
    "value": "Pondok Labu"
  },
  {
    "label": "Pondok Pinang",
    "value": "Pondok Pinang"
  },
  {
    "label": "Lebak Bulus",
    "value": "Lebak Bulus"
  },
  {
    "label": "Ulujami",
    "value": "Ulujami"
  },
  {
    "label": "Pesanggrahan",
    "value": "Pesanggrahan"
  },
  {
    "label": "Bintaro",
    "value": "Bintaro"
  },
  {
    "label": "Petukangan Utara",
    "value": "Petukangan Utara"
  },
  {
    "label": "Petukangan Selatan",
    "value": "Petukangan Selatan"
  },
  {
    "label": "Kebayoran Lama Selatan",
    "value": "Kebayoran Lama Selatan"
  },
  {
    "label": "Kebayoran Lama Utara",
    "value": "Kebayoran Lama Utara"
  },
  {
    "label": "Pejaten Barat",
    "value": "Pejaten Barat"
  },
  {
    "label": "Pejaten Timur",
    "value": "Pejaten Timur"
  },
  {
    "label": "Kalibata",
    "value": "Kalibata"
  },
  {
    "label": "Pancoran",
    "value": "Pancoran"
  },
  {
    "label": "Rawajati",
    "value": "Rawajati"
  },
  {
    "label": "Duren Tiga",
    "value": "Duren Tiga"
  },
  {
    "label": "Cikoko",
    "value": "Cikoko"
  },
  {
    "label": "Kuningan Barat",
    "value": "Kuningan Barat"
  },
  {
    "label": "Menteng Dalam",
    "value": "Menteng Dalam"
  },
  {
    "label": "Pasar Minggu",
    "value": "Pasar Minggu"
  },
  {
    "label": "Ragunan",
    "value": "Ragunan"
  },
  {
    "label": "Jati Padang",
    "value": "Jati Padang"
  },
  {
    "label": "Kebagusan",
    "value": "Kebagusan"
  },
  {
    "label": "Lenteng Agung",
    "value": "Lenteng Agung"
  },
  {
    "label": "Tanjung Barat",
    "value": "Tanjung Barat"
  },
  {
    "label": "Jagakarsa",
    "value": "Jagakarsa"
  },
  {
    "label": "Cipinang",
    "value": "Cipinang"
  },
  {
    "label": "Cipinang Besar Selatan",
    "value": "Cipinang Besar Selatan"
  },
  {
    "label": "Cipinang Besar Utara",
    "value": "Cipinang Besar Utara"
  },
  {
    "label": "Cipinang Cempedak",
    "value": "Cipinang Cempedak"
  },
  {
    "label": "Cipinang Muara",
    "value": "Cipinang Muara"
  },
  {
    "label": "Bali Mester",
    "value": "Bali Mester"
  },
  {
    "label": "Bidaracina",
    "value": "Bidaracina"
  },
  {
    "label": "Kampung Melayu",
    "value": "Kampung Melayu"
  },
  {
    "label": "Rawa Bunga",
    "value": "Rawa Bunga"
  },
  {
    "label": "Kayu Manis",
    "value": "Kayu Manis"
  },
  {
    "label": "Pal Meriam",
    "value": "Pal Meriam"
  },
  {
    "label": "Pisangan Baru",
    "value": "Pisangan Baru"
  },
  {
    "label": "Utankayu Selatan",
    "value": "Utankayu Selatan"
  },
  {
    "label": "Utankayu Utara",
    "value": "Utankayu Utara"
  },
  {
    "label": "Kramat Jati",
    "value": "Kramat Jati"
  },
  {
    "label": "Dukuh",
    "value": "Dukuh"
  },
  {
    "label": "Batuampar",
    "value": "Batuampar"
  },
  {
    "label": "Balekambang",
    "value": "Balekambang"
  },
  {
    "label": "Cililitan",
    "value": "Cililitan"
  },
  {
    "label": "Cawang",
    "value": "Cawang"
  },
  {
    "label": "Halim Perdanakusuma",
    "value": "Halim Perdanakusuma"
  },
  {
    "label": "Makasar",
    "value": "Makasar"
  },
  {
    "label": "Kebon Pala",
    "value": "Kebon Pala"
  },
  {
    "label": "Pinang Ranti",
    "value": "Pinang Ranti"
  },
  {
    "label": "Halim PK",
    "value": "Halim PK"
  },
  {
    "label": "Pondok Bambu",
    "value": "Pondok Bambu"
  },
  {
    "label": "Pondok Kelapa",
    "value": "Pondok Kelapa"
  },
  {
    "label": "Malaka Jaya",
    "value": "Malaka Jaya"
  },
  {
    "label": "Malaka Sari",
    "value": "Malaka Sari"
  },
  {
    "label": "Duren Sawit",
    "value": "Duren Sawit"
  },
  {
    "label": "Klender",
    "value": "Klender"
  },
  {
    "label": "Jatinegara Kaum",
    "value": "Jatinegara Kaum"
  },
  {
    "label": "Rawamangun",
    "value": "Rawamangun"
  },
  {
    "label": "Pulo Gadung",
    "value": "Pulo Gadung"
  },
  {
    "label": "Pisangan Timur",
    "value": "Pisangan Timur"
  },
  {
    "label": "Jati",
    "value": "Jati"
  },
  {
    "label": "Kayu Putih",
    "value": "Kayu Putih"
  },
  {
    "label": "Cakung Barat",
    "value": "Cakung Barat"
  },
  {
    "label": "Cakung Timur",
    "value": "Cakung Timur"
  },
  {
    "label": "Penggilingan",
    "value": "Penggilingan"
  },
  {
    "label": "Pulo Gebang",
    "value": "Pulo Gebang"
  },
  {
    "label": "Rawa Terate",
    "value": "Rawa Terate"
  },
  {
    "label": "Ujung Menteng",
    "value": "Ujung Menteng"
  },
  {
    "label": "Jatinegara",
    "value": "Jatinegara"
  },
  {
    "label": "Bambu Apus",
    "value": "Bambu Apus"
  },
  {
    "label": "Cilangkap",
    "value": "Cilangkap"
  },
  {
    "label": "Setu",
    "value": "Setu"
  },
  {
    "label": "Lubang Buaya",
    "value": "Lubang Buaya"
  },
  {
    "label": "Ceger",
    "value": "Ceger"
  },
  {
    "label": "Pondok Ranggon",
    "value": "Pondok Ranggon"
  }
]

export { peruntukanBangunan, sumberAir, jenisGalian, skemaPembayaran, peruntukanRegistrasi, kategoriPeruntukanRegistrasi, districts, cancelReason }